import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import ValidationErrorsService from '../../Services/ValidationErrorsService';
import AssetValidationErrorsDisplay from './AssetValidationErrorsDisplay';

const initState = {
  dataLoading: true,
  data: [],
  error: '',
};

export default function AssetValidationErrorsContainer(props) {
  const [state, updateState] = useState(initState);
  const [error, setError] = useState('');
  const { asset: { _id: assetID = '' } = {} } = props;

  let source = CancelToken.source();
  const validationErrorsService = new ValidationErrorsService();

  const updateValidationErrorsState = async () => {
    try {
      updateState({ ...state, dataLoading: true });
      const { errors: data = [] } =
        await validationErrorsService.fetchValidationErrors(
          assetID,
          {},
          source.token
        );
      updateState({
        ...state,
        data,
        dataLoading: false,
      });
    } catch (err) {
      if (isCancel(err)) return;
      setError(err.response?.data?.message ?? err.message);
      updateState({ ...state, dataLoading: false });
    }
  };

  useEffect(() => {
    if (!assetID) return;
    source = CancelToken.source();
    updateValidationErrorsState();
    return source.cancel;
  }, [assetID]);

  return (
    <AssetValidationErrorsDisplay
      {...props}
      {...state}
      tab="validationErrors"
      error={error}
      setError={setError}
      dataLoading={state.dataLoading}
    />
  );
}

AssetValidationErrorsContainer.propTypes = {
  asset: PropTypes.shape({
    _id: PropTypes.string,
    orgID: PropTypes.string,
  }),
};

AssetValidationErrorsContainer.defaultProps = {
  asset: {},
};
